module.exports = __webpack_public_path__ + "static/media/bill-importFromXero.b1e9361a.svg";